var map = {
	"./blogger.js": 23,
	"./collections.js": 24,
	"./delicious.js": 25,
	"./digg.js": 26,
	"./evernote.js": 27,
	"./facebook.js": 28,
	"./linkedin.js": 29,
	"./lj.js": 30,
	"./messenger.js": 31,
	"./moimir.js": 32,
	"./odnoklassniki.js": 33,
	"./pinterest.js": 34,
	"./pocket.js": 35,
	"./qzone.js": 36,
	"./reddit.js": 37,
	"./renren.js": 38,
	"./sinaWeibo.js": 39,
	"./skype.js": 40,
	"./surfingbird.js": 41,
	"./telegram.js": 42,
	"./tencentWeibo.js": 43,
	"./tumblr.js": 44,
	"./twitter.js": 45,
	"./viber.js": 46,
	"./vkontakte.js": 47,
	"./whatsapp.js": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;